import axios from "../../../lib/axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IVariant, VariantFormValues } from "../../../types/api/product";
import { AxiosResponse } from "axios";

export async function variantList(
  qData: QData & { productId?: string; search?: string }
): Promise<AxiosResponse<TResponseWithQData<IVariant[]>>> {
  return axios.get(API_ENDPOINTS.VARIANT_LIST, { params: qData });
}

export async function variantDetail(
  id: string
): Promise<AxiosResponse<TResponse<IVariant>>> {
  return axios.get(`${API_ENDPOINTS.VARIANT_DETAIL}/${id}`);
}

export async function createVariant(
  data: VariantFormValues & { productId: string }
): Promise<AxiosResponse<TResponse<IVariant>>> {
  return axios.post<TResponse<IVariant>>(API_ENDPOINTS.VARIANT_CREATE, data);
}

export async function updateVariant({
  id,
  data,
}: {
  id: string;
  data: Partial<VariantFormValues & { productId: string, isDefault: boolean }>;
}): Promise<AxiosResponse<TResponse<IVariant>>> {
  return axios.put<TResponse<IVariant>>(`${API_ENDPOINTS.VARIANT_UPDATE}/${id}`, data);
}

export async function deleteVariant(
  id: string
): Promise<AxiosResponse<TResponse<null>>> {
  return axios.delete<TResponse<null>>(`${API_ENDPOINTS.VARIANT_DELETE}/${id}`);
}
